export const INIT_NEWS = {
    id: null,
    title: null,
    description: null,
    // author: null,
    thumbAttachId: null,
    thumbAttachExt: null,

    // 图文控制项，链接图文不启用
    newsCommentType: 0,
    newsAccessType: 1,
    newsContentForbidCopy: false,
    newsContentMask: false,
    newsShowReadNum: true,
    newsShowPraiseNum: true,

    // 上传时生成的 data object 格式的缩略图 url，用于预览使用
    thumbUrl: null,

    // 上传图文附件配置
    entrypointId: null,
    entrypointPath: null,
};
